import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Ticket} from '../../../domain/tickets';
import {FormService} from '../../../services/formServices';
import {DataTableResource} from 'angular5-data-table';
import {SessionService} from '../../../../core/services/sessionService';

@Component({
  selector: 'app-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.scss']
})
export class StateComponent implements OnInit {
  userId: number;
  tickets: Array<Ticket>;
  ticketsResource: any;
  ticketsCount = 0;
  data: any;
  constructor(private ticketService: FormService,
              private route: ActivatedRoute,
              private sessionService: SessionService) { }

  ngOnInit() {
    this.data = this.sessionService.getSession();
    this.route.params.subscribe(
        params => {
            this.userId = params['id'];
        }
    );
    this.ticketService.getTicketsUser2(this.userId).subscribe(
        tickets => this.tickets = tickets
    );
      this.ticketsResource = new DataTableResource(this.tickets);
      this.ticketsResource.count().then(count => this.ticketsCount = count);
  }

    reloadItems(params) {
        this.ticketService.getTicketsUser2(this.userId).subscribe(
            tickets => this.tickets = tickets
        );
    }

    // special properties:
    rowClick(rowEvent) {
    }

    rowDoubleClick(rowEvent) {
    }

    rowTooltip(item) { return item.estado; }


}



// WEBPACK FOOTER //
// ./src/app/shared/modules/angular5-data-table/state/state.component.ts